import React, { useEffect, useState } from 'react';
import "./myProperties.scss";
import { useNavigate }     from 'react-router-dom';
import CardComponent       from '../../reuseableComponents/CardComponent/CardComponent';
import HeadingNDescription from '../../reuseableComponents/headingNDescription/headingNDescription';
import {PlusCircleFilled}  from '@ant-design/icons';
import Notification         from '../../reuseableComponents/Notification';
import { getMyPropertiesApi } from './apis/apis';

const MyProperties = () => {
  const [state, setState] = useState({
    myProperties:[],
    refresh : true
  })
  const navigate = useNavigate()
  const getMyPropertiesFunction = async () => {
    try {
      let result = await getMyPropertiesApi()
      if (result?.status) {
        setState({
          ...state,
          myProperties: result.data.data,
        })
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };
  useEffect(() => {
    getMyPropertiesFunction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.refresh]);

  return <div className={"myPropertiesContainer"}>
    <div className={"all-container"}>
      <HeadingNDescription
        style={{
          marginTop:0
        }}
        heading={ "My Properties" }
                           description={ "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s," }/>

      <div style={{
        marginTop:40
      }}/>
      <div className={ "content" }>
        <div style={ {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#F3F3F3",
          borderRadius: 10,
          height: "200px",
          width: "60%",
          margin: "auto",
          cursor: "pointer"
        } } onClick={ () => navigate("/addProperty") }>
          <PlusCircleFilled style={ {
            color: "#246BFD",
            fontSize: 20
          } }/>
          <h5 style={ {
            marginTop: 10
          } }>Add Property</h5>
        </div>
        {
          state.myProperties.map(item=><CardComponent data={item} cardType={"myProperty"} refreshState={state.refresh} refresh={(data)=> setState({...state, refresh: data})}/>)
        }
      </div>
    </div>
  </div>
}
export default MyProperties